module.exports = __webpack_public_path__ + "img/logo-tag-manager.d83eda26.jpg";